module.exports = __webpack_public_path__ + "static/media/breakfast6.a0badb89.png";